import * as React from 'react';
import {
  Box,
  Button,
  Title,
  ModalHeader,
  ModalSeparator,
  ModalFooter,
  Form,
  LoadingOr,
  Paragraph,
  ModalSection,
  FormGroup,
} from '@zen-common/components-base';
import { NamingUtils, TechnicalData as TD } from '@zen/common-app-parts';
import { numberUtils, textUtils } from '@zen/common-utils';

/**
 * @param {Object} props
 * @param {boolean} props.progress
 * @param {() => void} props.onCancel
 * @param {() => void} props.onContinue
 * @param {{name:string, shortName:string}} props.assetMetadata
 * @param {string} props.committedValue
 */
export default function DestroyFormModalContent({
  progress,
  onCancel,
  onContinue,
  assetMetadata,
  committedValue,
}) {
  function handleSubmit(e) {
    e.preventDefault();

    onContinue();
  }
  return (
    <Box>
      <ModalHeader>
        <Title>Your asset is not redeemable</Title>
        <Paragraph>Your position asset does not match the winning event</Paragraph>
      </ModalHeader>
      <Form onSubmit={handleSubmit} disabled={progress}>
        <ModalSection>
          <FormGroup>
            <Box>
              <TD.Label>Ticker:</TD.Label>
              <TD.Value>{NamingUtils.getRedeemableTickerData(assetMetadata.name)}</TD.Value>
            </Box>
          </FormGroup>
          <FormGroup>
            <Box>
              <TD.Label>Event Date:</TD.Label>
              <TD.Value>
                {textUtils.getDateStringFromTimestamp(
                  NamingUtils.getRedeemableEODTimestamp(assetMetadata.name)
                )}
              </TD.Value>
            </Box>
          </FormGroup>
          <FormGroup>
            <Box>
              <TD.Label>Event Price:</TD.Label>
              <TD.Value>
                $ {numberUtils.getPrice(NamingUtils.getRedeemablePriceData(assetMetadata.name))}
              </TD.Value>
            </Box>
          </FormGroup>
          <FormGroup>
            <Box>
              <TD.Label>Committed Price:</TD.Label>
              <TD.Value>$ {numberUtils.getPrice(committedValue)}</TD.Value>
            </Box>
          </FormGroup>
          <FormGroup>
            <Box>
              <TD.Label>Your Token Position:</TD.Label>
              <TD.Value>{NamingUtils.getRedeemablePositionData(assetMetadata.name)}</TD.Value>
            </Box>
          </FormGroup>
          <FormGroup>
            <Box>
              <TD.Label>Winning Position:</TD.Label>
              <TD.Value>
                {NamingUtils.getRedeemablePositionData(assetMetadata.name) === 'Bull'
                  ? 'Bear'
                  : 'Bull'}
              </TD.Value>
            </Box>
          </FormGroup>
        </ModalSection>
        <ModalSeparator />
        <ModalFooter>
          <Button type="button" onClick={onCancel} bg="secondary" disabled={progress}>
            Cancel
          </Button>
          <Button type="submit" disabled={progress}>
            <LoadingOr loading={progress}>Destroy</LoadingOr>
          </Button>
        </ModalFooter>
      </Form>
    </Box>
  );
}
